/**
 * Builds the path for Thescon Agent with optional scope query params.
 * Company-only scope uses `companyId`; knowledge collections use `knowledgeId` (Firestore `knowledge/{id}/…`).
 */
export function buildThesconAiPath(options: {
  /** Active persisted chat — drives Firestore scope when set. */
  threadId?: string;
  projectId?: string;
  companyId?: string;
  knowledgeId?: string;
  projectDocumentIds?: string[];
  companyDocumentIds?: string[];
  knowledgeDocumentIds?: string[];
}): string {
  const {
    threadId,
    projectId,
    companyId,
    knowledgeId,
    projectDocumentIds = [],
    companyDocumentIds = [],
    knowledgeDocumentIds = [],
  } = options;
  const params = new URLSearchParams();
  if (threadId) params.set('threadId', threadId);
  if (projectId) params.set('projectId', projectId);
  if (companyId) params.set('companyId', companyId);
  if (knowledgeId) params.set('knowledgeId', knowledgeId);
  if (projectDocumentIds.length > 0) params.set('projectDocumentIds', projectDocumentIds.join(','));
  if (companyDocumentIds.length > 0) params.set('companyDocumentIds', companyDocumentIds.join(','));
  if (knowledgeDocumentIds.length > 0) params.set('knowledgeDocumentIds', knowledgeDocumentIds.join(','));
  const q = params.toString();
  return q ? `/thescon-ai?${q}` : '/thescon-ai';
}
